export default __webpack_public_path__ + "444d867ce52c76d3586a27197a6519c2.png";